/*
* Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
* See LICENSE in the project root for license information.
*/

function onNewMessageComposeHandler(event) {
    setSignature(event);
}
function onNewAppointmentComposeHandler(event) {
    setSignature(event);
}
function setSignature(event) {
    fetch('https://api.signatyr.com/api/user?email=' + Office.context.mailbox.userProfile.emailAddress,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }
    ).then((response) => {
        return response.json();
    })
        .then((data) => {
            // Show a notification message.
            if (Office.context.mailbox.item.inReplyTo == null) {
                if (data.signature.compose == 1) {
                    Office.context.mailbox.item.body.setSignatureAsync(data.signature.content,
                        { coercionType: "html" },
                        function (asyncResult) {
                            console.log(`setSignatureAsync: ${asyncResult.status}`);
                        }
                    );
                }
            }
            else{
                if (data.signature.reply == 1) {
                    Office.context.mailbox.item.body.setSignatureAsync(data.signature.content,
                        { coercionType: "html" },
                        function (asyncResult) {
                            console.log(`setSignatureAsync: ${asyncResult.status}`);
                        }
                    );
                }
            }
        });
}

// IMPORTANT: To ensure your add-in is supported in Outlook, remember to map the event handler name specified in the manifest to its JavaScript counterpart.
Office.actions.associate("onNewMessageComposeHandler", onNewMessageComposeHandler);
Office.actions.associate("onNewAppointmentComposeHandler", onNewAppointmentComposeHandler);